import { createRouter, createWebHashHistory } from 'vue-router'

// stop the browser from restoring its own remembered scroll position on reload/back-forward -
// scrollBehavior below is the single source of truth for where the page lands
if ('scrollRestoration' in window.history) {
	window.history.scrollRestoration = 'manual'
}

const Home = () => import('../views/Home.vue')
const AboutUs = () => import('../views/AboutUs.vue')
const Contact = () => import('../views/Contact.vue')
const Results = () => import('../views/Results.vue')
const Schedule = () => import('../views/Schedule.vue')
const Gallery = () => import('../views/Gallery.vue')
const NotFound = () => import('../views/NotFound.vue')

const SITE_NAME = 'Karate klub Bregana'

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: {
			description: 'Karate klub Bregana - klub za djecu i odrasle u Bregani od 2001. godine. Treninzi, natjecanja i rezultati.',
		},
	},
	{
		path: '/about',
		name: 'AboutUs',
		component: AboutUs,
		meta: {
			title: 'O nama',
			description: 'Povijest kluba, trener Goran Romić i najuspješniji sportaši Karate kluba Bregana.',
		},
	},
	{ path: '/karate', redirect: '/about' },
	{
		path: '/schedule',
		name: 'Schedule',
		component: Schedule,
		meta: {
			title: 'Raspored i cijene',
			description: 'Raspored treninga po uzrastima i cijene članarine u Karate klubu Bregana.',
		},
	},
	{
		path: '/gallery',
		name: 'Gallery',
		component: Gallery,
		meta: {
			title: 'Galerija',
			description: 'Fotografije s treninga i natjecanja Karate kluba Bregana.',
		},
	},
	{
		path: '/results',
		name: 'Results',
		component: Results,
		meta: {
			title: 'Rezultati',
			description: 'Klupski rezultati na natjecanjima Karate kluba Bregana od 2002. do 2026. godine.',
		},
	},
	{
		path: '/contact',
		name: 'Contact',
		component: Contact,
		meta: {
			title: 'Kontakt',
			description: 'Adresa, telefon i kontakt podaci Karate kluba Bregana u Bregani.',
		},
	},
	{
		path: '/:pathMatch(.*)*',
		name: 'NotFound',
		component: NotFound,
		meta: { title: 'Stranica nije pronađena' },
	},
]

const router = createRouter({
	history: createWebHashHistory(),
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) return savedPosition
		return { top: 0 }
	},
})

router.afterEach((to) => {
	document.title = to.meta.title ? `${to.meta.title} — ${SITE_NAME}` : SITE_NAME

	let descriptionTag = document.querySelector('meta[name="description"]')
	if (!descriptionTag) {
		descriptionTag = document.createElement('meta')
		descriptionTag.setAttribute('name', 'description')
		document.head.appendChild(descriptionTag)
	}
	descriptionTag.setAttribute('content', to.meta.description || SITE_NAME)
})

export default router
